import React, { Component } from "react";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as checkinConstant from './constants'
import * as checkinAction from './actions'
import DisplayRecordText from "../controls/_DisplayRecordText"
import GoogleMapControl from "../controls/GoogleMapControl"
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import Moment from "react-moment"
import { storedb } from '../../views/client/storedb'
import AppConfig from '../../config/app'
import { confirmAlert } from 'react-confirm-alert';
import Camera, { IMAGE_TYPES } from 'react-html5-camera-photo';
import { DataURLtoFile, GetCurrentDayName } from '../../lib/common'
import CheckboxTreeList from "../controls/_CheckboxTreeList";
class Checkin extends Component {
  constructor(props) {
    super(props);
    let dbContext = storedb()
    this.state = {
      store_id: dbContext.getStoreId(),
      list: [],
      per_page: 20,
      page: 1,
      total_record: 0,
      latitude: 0,
      longitude: 0,
      address: '',
      GoogleMapApiKey: dbContext.getSettingValue(AppConfig.SETTINGKEYS.GoogleMapsApiKey, "AIzaSyDJnkap7hCki7fnfrEjossfFqFaRQ-coC4"),
      imgData: null,
      urlToHugeImageFile: null,
      urlToHugeImageTitle: '',
      fileName: `${Math.random(10)}.jpg`,
      treeKH: [],
      multipleValueNVKD: [],
      multipleValueKH: [],
      treeNvkd: [],
      treeKH: [],
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }

  fetchList = () => {
    const { checkinListRequest } = this.props
    var requestData = {
      page: this.state.page,
      per_page: this.state.per_page
    };
    return checkinListRequest(requestData);
  }
  search = () => {
    if (this.props.checkin.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  GetGeoLocation = (callback) => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        if (typeof position !== 'undefined') {
          callback(position)
        }
      },
      function (error) {
        console.error("GetGeoLocation Code = " + error.code + " - " + error.message);
      }
    );
  }
  GetLocationName = (lat, lng, callback) => {
    if (window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      const my_location = {
        lat: lat,
        lng: lng
      };
      geocoder.geocode({ 'latLng': my_location }, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            callback(results[0].formatted_address)
          }
        }
      });
    }
  }
  GetCurrentLocation = () => {
    this.GetGeoLocation((position) => {
      this.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      }, () => {
        this.GetLocationName(position.coords.latitude, position.coords.longitude, (address) => {
          this.setState({ address: address })
        })
      })
    })
  }
  viewImageHurge = (e, imgSrc, imgTitle) => {
    e.preventDefault()
    this.setState({ urlToHugeImageFile: imgSrc, urlToHugeImageTitle: imgTitle })
  }
  closeViewImageHurge = () => {
    this.setState({
      urlToHugeImageFile: null,
      urlToHugeImageTitle: ''
    });
    this.props.onClose();
  }
  viewLocation = (e, lat, long) => {
    e.preventDefault()
    const url = 'http://maps.google.com/?q=' + lat + ',' + long;
    window.open(url, '_blank');
  }
  processCheckinClick = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn checkin tại vị trí:</p> <p className="text-danger">{this.state.address}</p>
            <button className="text-danger" onClick={() => {
              this.HandleCheckInUser();
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  HandleCurrentLocation = (e) => {
    e.preventDefault()
    this.GetCurrentLocation();
  }
  HandleCheckInUser = () => {
    var khachHangId = this.state.multipleValueKH[0] || 0
    var khachHang = []
    if (khachHangId) {
      khachHang = this.state.treeKH.filter(x => x.Id == khachHangId)
    }
    const { checkinUpdateRequest } = this.props
    const formData = new FormData();
    formData.append('latitude', this.state.latitude)
    formData.append('longitude', this.state.longitude)
    formData.append('address', this.state.address)
    formData.append('file', this.state.imgData != null ? DataURLtoFile(this.state.imgData, this.state.fileName) : null)
    formData.append('khachHangId', khachHangId)
    formData.append('tenKhachHang', khachHang.length > 0 ? khachHang[0].Name : null)
    formData.append('maKhachHang', khachHang.length > 0 ? khachHang[0].SubName : null)
    formData.append('ngayCheckIn', GetCurrentDayName() || null)
    return checkinUpdateRequest(formData, () => {
      this.search()
    });
  }
  onTakePhoto = (imgData) => {
    this.setState({ imgData })
  }
  onReTakePhoto = () => {
    this.setState({ imgData: null })
  }
  onHandleRemoveNvkd = () => {
    this.setState({ multipleValueNVKD: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNVKD: multipleValue })
    if (multipleValue.length > 0) {
      this.fetchKH(multipleValue);
    } else {
      this.setState({ multipleValueKH: [] });
    }
  }

  onHandleRemoveKH = () => {
    this.setState({ multipleValueKH: [] })
  }
  onHandleChoiceKH = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueKH: multipleValue })
  }

  fetchNvkd = (quanlys) => {
    const { checkinReportNvkdRequest } = this.props
    var requestData = {
      store_id: this.state.store_id,
      userIds: quanlys
    };
    return checkinReportNvkdRequest(requestData);
  }
  fetchKH = (nvkds) => {
    const { checkinKhachHangRequest } = this.props
    var requestData = {
      stores_id: this.state.store_id,
      nvkds: nvkds
    };
    return checkinKhachHangRequest(requestData, (data) => {
      this.setState({ treeKH: data })
    });
  }

  componentDidMount() {
    this.GetCurrentLocation();
    this.search();
    this.fetchNvkd();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.checkin.type == checkinConstant.CHECKIN_LIST_SUCCESS) {
      let { list, item } = nextProps.checkin;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    } else if (nextProps.checkin.type == checkinConstant.CHECKIN_REPORT_NVKD_SUCCESS) {
      let { listNVKD } = nextProps.checkin;
      if (listNVKD && listNVKD.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        const NvkdChecked = listNVKD.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNvkd(NvkdChecked)
      };
      this.setState({
        treeNvkd: listNVKD
      });
    }
  }
  render() {
    const {
      checkin: {
        isRequesting,
        list,
        errors,
        messages
      },
    } = this.props
    const { imgData, urlToHugeImageFile, urlToHugeImageTitle, treeNvkd, treeKH } = this.state
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={isRequesting} >
          <div>
            <Collapsible trigger="Bản đồ vị trí" open={true} contentInnerClassName="p-0">
              <div className="row m-0">
                <div className="col-sm-3 p-0">
                  {
                    (imgData != null)
                      ? <div style={{ width: "100%" }}>
                        <img style={{ width: "100%" }} src={imgData} />
                        <div id="container-circles" onClick={this.onReTakePhoto}>
                          <div id="outer-circle"><div id="inner-circle"></div></div>
                        </div>
                      </div>
                      : <Camera
                        onTakePhoto={this.onTakePhoto}
                        imageType={IMAGE_TYPES.JPG}
                        imageCompression={0.97}
                      />
                  }
                </div>
                <div className="col-sm-9">
                  <GoogleMapControl
                    latitude={this.state.latitude}
                    longitude={this.state.longitude}
                    googleMapsApiKey={this.state.GoogleMapApiKey}
                  />
                </div>
              </div>
            </Collapsible>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {!isRequesting && !!(errors || []).length && (
                <Errors errors={errors} />
              )}
              {!isRequesting && !!(messages || []).length && (
                <Messages messages={messages} />
              )}
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={(e) => this.HandleCurrentLocation(e)}><i className="fa fa-map-marker"></i> Định vị</Button>
              <label className="p-2">Bạn đang ở vị trí: <span className="text-danger font-weight-bold">{this.state.address}</span></label>
            </div>
            <div className="row">
              <div className="col-sm-6 mb-2">
                <InputGroup size="md">
                  <CheckboxTreeList
                    placeholder={`--Nhân viên KD--`}
                    nodes={treeNvkd}
                    isMultiChoice={false}
                    checked={this.state.multipleValueNVKD}
                    onChoice={e => this.onHandleChoiceNvkd(e)}
                  />
                </InputGroup>
              </div>
              <div className="col-sm-6 mb-2">
                <InputGroup size="md">
                  <CheckboxTreeList
                    placeholder={`--Khách hàng--`}
                    nodes={treeKH}
                    isMultiChoice={false}
                    checked={this.state.multipleValueKH}
                    onHandleRemove={(item) => this.onHandleRemoveKH(item)}
                    onChoice={e => this.onHandleChoiceKH(e)}
                  />
                </InputGroup>
              </div>
              <div className="col-sm-12">
                <ButtonExt className="mr-1"
                  isDisabled={this.state.address == '' ? true : false}
                  color="primary"
                  iconClass="fa-map-pin"
                  displayText="Check in"
                  btnClick={() => this.processCheckinClick()}
                  permission={BtnPermissions.Checkin.ADD_OR_UPDATE} />
              </div>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="40" className="text-center">#</th>
                    <th scope="col" className="text-left">Thời gian</th>
                    <th scope="col" className="text-left">Lịch chăm sóc</th>
                    <th scope="col" className="text-left">Khách hàng</th>
                    <th scope="col" className="text-left">Địa chỉ</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.NgayTao && <Moment format="HH:mm DD/MM/YYYY">{`${res.NgayTao}`}</Moment>}</td>
                        <td className="text-left">{res.NgayCheckIn}</td>
                        <td className="text-left">{res.MaKhachHang}-{res.TenKhachHang}</td>
                        <td className="text-left"><a className="text-primary font-weigh-bold" onClick={(e) => this.viewLocation(e, res.Latitude, res.Longtitude)}>{res.DiaChi}</a></td>
                        <td className="text-right"><img style={{ cursor: "pointer" }} width="100px" src={res.ImageCheckin} onClick={(e) => this.viewImageHurge(e, res.ImageCheckin, res.TenNhanVien)} /></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          {/* hien thi ảnh checkin lên popup */}
          <Modal isOpen={urlToHugeImageFile != null} className="modal-lg">
            <ModalHeader style={{ padding: '0.5rem' }}>{urlToHugeImageTitle}</ModalHeader>
            <ModalBody>
              <img style={{ width: "100%" }} src={urlToHugeImageFile} className="img-fluid" />
            </ModalBody>
            <ModalFooter className="p-1">
              <Button color="danger" className="ml-2" onClick={this.closeViewImageHurge.bind(this)}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
            </ModalFooter>
          </Modal>
        </BlockUi >
      </div >
    )
  }
}
const mapStateToProps = state => ({
  checkin: state.checkin,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  checkinListRequest: checkinAction.checkinListRequest,
  checkinUpdateRequest: checkinAction.checkinUpdateRequest,
  checkinKhachHangRequest: checkinAction.checkinKhachHangRequest,
  checkinReportNvkdRequest: checkinAction.checkinReportNvkdRequest,
})(Checkin)
const formed = reduxForm({
  form: 'checkin',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/Checkin/Checkin.js